import { GeolocationContext } from '@/contexts/geolocation-context';
import { use } from 'react';

export function useGeolocation() {
  const context = use(GeolocationContext);

  if (!context) {
    throw new Error('useGeolocation must be used within a GeolocationProvider');
  }

  return context;
}
